export enum PoolType {
  Weighted = 'Weighted',
  Stable = 'Stable',
  ConstantSum = 'ConstantSum',
}
